<template>
  <div class="note-menu-modal" v-if="note">
    <div class="modal-overlay" @click="$emit('close')"></div>
    <div class="modal-content">
      <div class="modal-handle"></div>
      
      <div class="note-info">
        <h3>{{ note.notename || 'Untitled Note' }}</h3>
        <p class="note-date">{{ formatDate(note.createtime) }}</p>
      </div>
      
      <div class="menu-options">
        <div class="menu-item" @click="handleRename">
          <div class="menu-icon rename-icon">✏️</div>
          <span>Rename</span>
        </div>
        
        <div class="menu-item" @click="handleMove">
          <div class="menu-icon move-icon">📁</div>
          <span>Move to Folder</span>
        </div>
        
        <div class="menu-item danger" @click="handleDelete">
          <div class="menu-icon delete-icon">🗑️</div>
          <span>Delete</span>
        </div>
      </div>
      
      <div class="modal-footer">
        <button class="cancel-btn" @click="$emit('close')">
          Cancel
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NoteMenuModal',
  props: {
    note: {
      type: Object,
      default: null
    }
  },
  emits: ['close', 'rename', 'move', 'delete'],
  methods: {
    formatDate(dateTime) {
      if (!dateTime) return ''
      
      const date = new Date(dateTime)
      const now = new Date()
      const diffTime = Math.abs(now - date)
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
      
      if (diffDays === 1) {
        return 'Today'
      } else if (diffDays === 2) {
        return 'Yesterday'
      } else if (diffDays < 7) {
        return `${diffDays - 1} days ago`
      } else {
        return date.toLocaleDateString('en-US', {
          year: 'numeric',
          month: 'short',
          day: 'numeric'
        })
      }
    },
    
    handleRename() {
      this.$emit('rename', this.note)
      this.$emit('close')
    },
    
    handleMove() {
      this.$emit('move', this.note)
      this.$emit('close')
    },
    
    handleDelete() {
      this.$emit('delete', this.note)
      this.$emit('close')
    }
  }
}
</script>

<style lang="less" scoped>
.note-menu-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  
  .modal-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(4px);
  }
  
  .modal-content {
    position: relative;
    width: 100%;
    background: white;
    border-radius: 24px 24px 0 0;
    box-shadow: 0 -10px 40px rgba(0, 0, 0, 0.15);
    animation: modalSlideUp 0.3s ease-out;
    padding-bottom: env(safe-area-inset-bottom, 0);
  }
  
  .modal-handle {
    width: 40px;
    height: 4px;
    background: #d1d5db;
    border-radius: 2px;
    margin: 12px auto 0;
  }
  
  .note-info {
    text-align: center;
    padding: 20px 24px 16px;
    border-bottom: 1px solid #f3f4f6;
    
    h3 {
      margin: 0 0 4px 0;
      font-size: 18px;
      font-weight: 600;
      color: #111827;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    
    .note-date {
      margin: 0;
      font-size: 14px;
      color: #6b7280;
    }
  }
  
  .menu-options {
    padding: 8px 0;
    
    .menu-item {
      display: flex;
      align-items: center;
      padding: 16px 24px;
      cursor: pointer;
      transition: background 0.2s ease;
      
      &:active {
        background: #f9fafb;
      }
      
      &.danger {
        color: #ef4444;
        
        &:active {
          background: #fef2f2;
        }
      }
      
      .menu-icon {
        width: 40px;
        height: 40px;
        border-radius: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 16px;
        font-size: 20px;
        
        &.rename-icon {
          background: #e0f2fe;
        }
        
        &.move-icon {
          background: #f3e8ff;
        }
        
        &.delete-icon {
          background: #fef2f2;
        }
      }
      
      span {
        font-size: 16px;
        font-weight: 500;
      }
    }
  }
  
  .modal-footer {
    padding: 16px 24px 24px;
    
    .cancel-btn {
      width: 100%;
      padding: 16px;
      border: none;
      border-radius: 12px;
      background: #f3f4f6;
      color: #374151;
      font-size: 16px;
      font-weight: 600;
      cursor: pointer;
      
      &:active {
        background: #e5e7eb;
      }
    }
  }
}

@keyframes modalSlideUp {
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
}
</style> 